import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { MarkAllReadResponse, NotificationDTO, UnreadCountResponse } from '../models/notification.types';

@Injectable({
    providedIn: 'root'
})
export class NotificationApiService {
    private _httpClient = inject(HttpClient);
    private readonly baseUrl = `${environment.baseUrl}/notifications`;

    /**
     * Get paginated notifications for the current user
     */
    getNotifications(page: number = 0, size: number = 20): Observable<NotificationDTO[]> {
        const params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString())
            .set('sort', 'createdDate,desc');

        return this._httpClient.get<NotificationDTO[]>(this.baseUrl, { params });
    }

    /**
     * Get unread notification count
     */
    getUnreadCount(): Observable<UnreadCountResponse> {
        return this._httpClient.get<UnreadCountResponse>(`${this.baseUrl}/unread-count`);
    }

    /**
     * Mark a notification as read
     */
    markAsRead(id: number): Observable<NotificationDTO> {
        return this._httpClient.put<NotificationDTO>(`${this.baseUrl}/${id}/read`, {});
    }

    /**
     * Mark all notifications as read
     */
    markAllAsRead(): Observable<MarkAllReadResponse> {
        return this._httpClient.put<MarkAllReadResponse>(`${this.baseUrl}/read-all`, {});
    }

    /**
     * Delete a notification
     */
    deleteNotification(id: number): Observable<void> {
        return this._httpClient.delete<void>(`${this.baseUrl}/${id}`);
    }
}
